import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import { withStyles } from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from "@material-ui/core/Checkbox";
import TextField from '@material-ui/core/TextField';
import { ViscosityCalculationService } from '../../services/bunkermaster/ViscosityCalculationService'
import ViscosityService from '../../services/bunkermaster/ViscocityConversionservice'
import { ViscosityTypes } from '../../services/bunkermaster/Settings'

import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';


import {
    FormHelperText,
    Input,
    InputLabel,
    InputBase,
} from "@material-ui/core";



const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);




function createData(Parameter, Unit) {
    return { Parameter, Unit };
}

const rows = [
    createData(' .', '. '),
    createData(' .  ', ' .'),
    createData(' .', '. '),

];


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const BootstrapInput = withStyles((theme) => ({
    root: {
        "label + &": {
            marginTop: theme.spacing(2),
        },
    },

    input: {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.common.white,
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "auto",
        padding: "10px 12px",
        height: "0.1876em",
        // marginLeft: '2.2em',
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
            // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },
    },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    btn1: {
        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '0 !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'

    },
    btn2: {

        border: '2px solid #FF4717',
        background: '#ff4717',
        color: '#fff !important',
        marginLeft: '20px !important',
        fontSize: '16px; font-weight: normal',
        padding: '8px 15px',
        width: '130px !important'
    },
    textstyles: {
        color: '#ff4717'
    }
}));

function ViscocityCal() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [Fuel, setFuel] = React.useState('')
    const [ViscocityResult, setViscocityResult] = React.useState({ FuelConstantA: "", FuelConstantB: "", ShellViscosityConstant: "", ViscosityIndex: "" })
    const [calcFields, setCalcFields] = React.useState({ ViscosityNo1: "", TemperatureNo1: "", ViscosityNo2: "", TemperatureNo2: "" })
    const [Temp, setTemp] = React.useState({ calcType: 10, ViscosityNo1: "", TemperatureNo1: "", ViscosityNo2: "", TemperatureNo2: "" });
    const [conv, setConv] = React.useState('')
    const [checkBox, setCheck] = React.useState({ disabled: true, checked: false });
    const [fieldClass, setFieldClass] = React.useState({ ViscosityNo1: true, TemperatureNo1: true, ViscosityNo2: true, TemperatureNo2: true });
    const [info, setInfo] = React.useState({ ViscosityNo1: true, TemperatureNo1: true, ViscosityNo2: true, TemperatureNo2: true });
    const [fieldClass2, setFieldClass2] = React.useState({ ViscosityNo1: true, TemperatureNo1: true, ViscosityNo2: true, TemperatureNo2: true });
    const [info2, setInfo2] = React.useState({ ViscosityNo1: true, TemperatureNo1: true, ViscosityNo2: true, TemperatureNo2: true });
    const [visresult, setResult] = React.useState({});
    const [viscosityState, setViscosityState] = React.useState({ ViscosityType: 1, viscosity: "" })
    const [error, setError] = React.useState({ msg: "kinematic Viscosity @50 \u00B0 C must be between 2 and 900 mm2/s.", style: "info padb15 " })
    const [validate, setValidate] = React.useState({ style: "mt0", msg: "", textstyle: "userinfo" })
    const [errVal, seterrVal] = React.useState("");
    const [errmsg, seterrmsg] = React.useState("");

    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);


    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const Calculation = () => {

        ;
        if (calcFields["ViscosityNo1"] === "") {
            let update = fieldClass;
            update["ViscosityNo1"] = false;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["TemperatureNo1"] === "") {
            let update = fieldClass;
            update["TemperatureNo1"] = false;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["ViscosityNo2"] === "") {
            let update = fieldClass;
            update["ViscosityNo2"] = false;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["TemperatureNo2"] === "") {
            let update = fieldClass;
            update["TemperatureNo2"] = false;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (info["ViscosityNo1"] === true && info["ViscosityNo2"] === true && info["TemperatureNo1"] === true && info["TemperatureNo2"] === true) {


            if (calcFields["ViscosityNo1"] !== "" && calcFields["TemperatureNo1"] !== "" && calcFields["ViscosityNo2"] !== "" && calcFields["TemperatureNo2"] !== "") {
                let result = ViscosityCalculationService.CalculateFuelConstants(
                    calcFields, ViscocityResult
                )

                let resultvar = ViscosityCalculationService.CalculateViscosityIndex(
                    calcFields, ViscocityResult
                )
                let output = ViscosityCalculationService.CalculateShellViscosityConstant(
                    calcFields, ViscocityResult
                )
                if (resultvar === "") {
                    output = ""
                    //val="errortext"
                    seterrVal("errortext");
                    //seterrmsg("Viscosity at 100oC must be between 2.0 and 1000mm2/s.");
                } else {
                    seterrVal("");
                    seterrmsg("")
                }

                if (result.FuelConstantA && result.FuelConstantB) {

                    setCheck({ ...checkBox, ...{ disabled: false } })
                }
                setViscocityResult({ ...result, ...resultvar, ...output });
            } else {
                setViscocityResult({ ...ViscocityResult, ...{ FuelConstantA: "", FuelConstantB: "", ShellViscosityConstant: "", ViscosityIndex: "" } });
            }
        } else {
            setViscocityResult({ ...ViscocityResult, ...{ FuelConstantA: "", FuelConstantB: "", ShellViscosityConstant: "", ViscosityIndex: "" } });
        }
    }
    const onResetconst = () => {
        ;
        setInfo({...info,...{ ViscosityNo1: true, TemperatureNo1: true, ViscosityNo2: true, TemperatureNo2: true }})
        setCalcFields({ ...calcFields, ...{ ViscosityNo1: "", TemperatureNo1: "", ViscosityNo2: "", TemperatureNo2: "" } })
        setViscocityResult({ ...ViscocityResult, ...{ FuelConstantA: "", FuelConstantB: "", ShellViscosityConstant: "", ViscosityIndex: "" } })
        seterrmsg("")
    }
    const onValuesChange = (value, field) => {
        

        let local = calcFields;
        local[field] = value;
        setCalcFields({ ...calcFields, ...local });
        if (calcFields["ViscosityNo1"] !== "") {
            let newupdate = fieldClass;
            newupdate["ViscosityNo1"] = true;
            setFieldClass({ ...fieldClass, ...newupdate });
        }
        if (calcFields["TemperatureNo1"] !== "") {
            let newupdate = fieldClass;
            newupdate["TemperatureNo1"] = true;
            setFieldClass({ ...fieldClass, ...newupdate });
        }
        if (calcFields["ViscosityNo2"] !== "") {
            let newupdate = fieldClass;
            newupdate["ViscosityNo2"] = true;
            setFieldClass({ ...fieldClass, ...newupdate });
        }
        if (calcFields["TemperatureNo2"] !== "") {
            let newupdate = fieldClass;
            newupdate["TemperatureNo2"] = true;
            setFieldClass({ ...fieldClass, ...newupdate });
        }



        if (field === "ViscosityNo1" && calcFields["ViscosityNo1"] >= 0 || calcFields["ViscosityNo1"] === "") {
            let newupdate = info;
            newupdate["ViscosityNo1"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "ViscosityNo1") {
            let newupdate = info;
            newupdate["ViscosityNo1"] = false;
            setInfo({ ...info, ...newupdate });
        }

        if (field === "TemperatureNo1" && calcFields["TemperatureNo1"] >= 0 || calcFields["TemperatureNo1"] === "") {
            let newupdate = info;
            newupdate["TemperatureNo1"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "TemperatureNo1") {
            let newupdate = info;
            newupdate["TemperatureNo1"] = false;
            setInfo({ ...info, ...newupdate });
        }
        if (field === "ViscosityNo2" && calcFields["ViscosityNo2"] >= 0.5 && calcFields["ViscosityNo2"] <= 5212 || calcFields["ViscosityNo2"] === "") {
            let newupdate = info;
            newupdate["ViscosityNo2"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "ViscosityNo2") {
            let newupdate = info;
            newupdate["ViscosityNo2"] = false;
            setInfo({ ...info, ...newupdate });
        }
        if (field === "TemperatureNo2" && calcFields["TemperatureNo2"] >= 0 || calcFields["TemperatureNo2"] === "") {
            let newupdate = info;
            newupdate["TemperatureNo2"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "TemperatureNo2") {
            let newupdate = info;
            newupdate["TemperatureNo2"] = false;
            setInfo({ ...info, ...newupdate });
        }



    }

    const onReset = () => {
        let update = error;
        update["style"] = "mt0";
        setError({ ...error, ...update });
        setViscosityState({ ...viscosityState, ...{ viscosity: "" } })
        setResult("")
    }
    const Derivative = () => {
        if (Temp["ViscosityNo1"] === "") {
            let update = fieldClass2;
            update["ViscosityNo1"] = false;
            setFieldClass2({ ...fieldClass2, ...update });
        }
        if (Temp["TemperatureNo1"] === "") {
            let update = fieldClass2;
            update["TemperatureNo1"] = false;
            setFieldClass2({ ...fieldClass2, ...update });
        }
        if (Temp["TemperatureNo2"] === "") {
            let update = fieldClass2;
            update["TemperatureNo2"] = false;
            setFieldClass2({ ...fieldClass2, ...update });
        }
        if (Temp["ViscosityNo2"] === "") {
            let update = fieldClass2;
            update["ViscosityNo2"] = false;
            setFieldClass2({ ...fieldClass2, ...update });
        }

        ;
        if (Temp.calcType === 10) {
            if (Temp["ViscosityNo1"] >= 0.5) {
                if (Temp["TemperatureNo1"] >= 0) {
                    if (Temp["TemperatureNo2"] >= 0) {
                        
                        let conversionResult = ViscosityCalculationService.CalculateViscTemp(
                            Temp, ViscocityResult, checkBox.checked
                        )
                        setConv(conversionResult)
                    }

                }

            }
        } else {
            if (Temp["ViscosityNo1"] >= 0.5) {
                if (Temp["TemperatureNo1"] >= 0) {
                    if (Temp["ViscosityNo2"] >= 0.5) {
                        
                        let conversionResult = ViscosityCalculationService.CalculateViscTemp(
                            Temp, ViscocityResult, checkBox.checked
                        )
                        setConv(conversionResult)
                    }

                }

            }
        }
    }
    const onResettemp = () => {
        ;
        
       
        setInfo2({...info2,...{ ViscosityNo1: true, TemperatureNo1: true, ViscosityNo2: true, TemperatureNo2: true }})
        setTemp({ ...Temp, ...{ ViscosityNo1: "", TemperatureNo1: "", ViscosityNo2: "", TemperatureNo2: "" } })
        setConv('')
    }

    const onChangestatus = (value, field) => {
        
        let local = Temp;
        local[field] = value;
        setTemp({ ...Temp, ...local });
        
        if (field === "calcType") {
            setConv('')
        }

        if (Temp["ViscosityNo1"] !== "") {
            let newupdate = fieldClass2;
            newupdate["ViscosityNo1"] = true;
            setFieldClass2({ ...fieldClass2, ...newupdate });
        }
        if (Temp["TemperatureNo1"] !== "") {
            let newupdate = fieldClass2;
            newupdate["TemperatureNo1"] = true;
            setFieldClass2({ ...fieldClass2, ...newupdate });
        }
        if (Temp["TemperatureNo2"] !== "") {
            let newupdate = fieldClass2;
            newupdate["TemperatureNo2"] = true;
            setFieldClass2({ ...fieldClass2, ...newupdate });
        }
        if (Temp["ViscosityNo2"] !== "") {
            let newupdate = fieldClass2;
            newupdate["ViscosityNo2"] = true;
            setFieldClass2({ ...fieldClass2, ...newupdate });
        }
        if (field === "ViscosityNo1" && Temp["ViscosityNo1"] >= 0 || Temp["ViscosityNo1"] === "") {
            let newupdate = info2;
            newupdate["ViscosityNo1"] = true;
            setInfo2({ ...info2, ...newupdate });
        } else if (field === "ViscosityNo1") {
            let newupdate = info2;
            newupdate["ViscosityNo1"] = false;
            setInfo2({ ...info2, ...newupdate });
        }
        if (field === "TemperatureNo1" && Temp["TemperatureNo1"] >= 0 || Temp["TemperatureNo1"] === "") {
            let newupdate = info2;
            newupdate["TemperatureNo1"] = true;
            setInfo2({ ...info2, ...newupdate });
        } else if (field === "TemperatureNo1") {
            let newupdate = info2;
            newupdate["TemperatureNo1"] = false;
            setInfo2({ ...info2, ...newupdate });
        }
        if (field === "TemperatureNo2" && Temp["TemperatureNo2"] >= 0 || Temp["TemperatureNo2"] === "") {
            let newupdate = info2;
            newupdate["TemperatureNo2"] = true;
            setInfo2({ ...info2, ...newupdate });
        } else if (field === "TemperatureNo2") {
            let newupdate = info2;
            newupdate["TemperatureNo2"] = false;
            setInfo2({ ...info2, ...newupdate });
        }

    }
    const onChecked = (value) => {
        setCheck({ ...checkBox, ...{ checked: value } })
    }
    const CalculationViscosityConversion = () => {
        ;
        if (viscosityState["viscosity"] === "") {
            let vali = validate;
            vali["style"] = "error";
            vali["textstyle"] = "errortext";
            vali["msg"] = "Field is Required !";
            setValidate({ ...validate, ...vali });
        } else {
            if (viscosityState["ViscosityType"] == 1 && viscosityState["viscosity"] >= 2 && viscosityState["viscosity"] <= 900) {
                let result = ViscosityService.CalculateViscosityConversion(
                    viscosityState
                )
                result["KinVisc50C"] = result["KinVisc50C"].toFixed();
                result["Engler"] = result["Engler"].toFixed(3);
                result["Redwood"] = result["Redwood"].toFixed();
                result["SSF"] = result["SSF"].toFixed(1);
                result["SSU122"] = result["SSU122"].toFixed();
                result["SSU210"] = result["SSU210"].toFixed(1);
                setResult(result);
            } else if (viscosityState["ViscosityType"] == 2 && viscosityState["viscosity"] >= 1.141 && viscosityState["viscosity"] <= 119.9) {
                let result = ViscosityService.CalculateViscosityConversion(
                    viscosityState
                )
                setResult(result);
            } else if (viscosityState["ViscosityType"] == 3 && viscosityState["viscosity"] >= 32.1 && viscosityState["viscosity"] <= 9600) {
                let result = ViscosityService.CalculateViscosityConversion(
                    viscosityState
                )
                setResult(result);
            } else if (viscosityState["ViscosityType"] == 4 && viscosityState["viscosity"] >= 21 && viscosityState["viscosity"] <= 425) {
                let result = ViscosityService.CalculateViscosityConversion(
                    viscosityState
                )
                setResult(result);
            } else if (viscosityState["ViscosityType"] == 5 && viscosityState["viscosity"] >= 32.6 && viscosityState["viscosity"] <= 4175) {
                let result = ViscosityService.CalculateViscosityConversion(
                    viscosityState
                )
                setResult(result);
            } else if (viscosityState["ViscosityType"] == 6 && viscosityState["viscosity"] >= 29.5 && viscosityState["viscosity"] <= 290) {
                let result = ViscosityService.CalculateViscosityConversion(
                    viscosityState
                )
                setResult(result);
            }
            else {
                setResult("");
            }
        }
    }

    const onViscosityValuesChange = (value, field) => {
        ;
        let local = viscosityState;
        local[field] = value;
        setViscosityState({ ...viscosityState, ...local });

        if (viscosityState["viscosity"] !== "") {
            let vali = validate;
            vali["style"] = "mt0";
            vali["textstyle"] = "userinfo";
            vali["msg"] = "";
            setValidate({ ...validate, ...vali });
        }

        if (field === "ViscosityType" && value === 1) {
            let update = error;
            update["msg"] = "kinematic Viscosity @50 \u00B0 C must be between 2 and 900 mm2/s.";
            setError({ ...error, ...update });
        }
        if (field === "ViscosityType" && value === 2) {
            let update = error;
            update["msg"] = "Viscosity in Engler must be between 1.141 and 119.9 Engler.";
            setError({ ...error, ...update });
        }
        if (field === "ViscosityType" && value === 3) {
            let update = error;
            update["msg"] = "Viscosity in Redwood No.1 must be between 32.1 and 9600 RW1.";
            setError({ ...error, ...update });
        }
        if (field === "ViscosityType" && value === 4) {
            let update = error;
            update["msg"] = "Viscosity in Saybolt Furol must be between 21 and 425 SSF @122 \u00B0 F.";
            setError({ ...error, ...update });
        }
        if (field === "ViscosityType" && value === 5) {
            let update = error;
            update["msg"] = "Viscosity in Saybolt Universal at 122 \u00B0 F must be between 32.6 and 4175.";
            setError({ ...error, ...update });
        }
        if (field === "ViscosityType" && value === 6) {
            let update = error;
            update["msg"] = "Viscosity in Saybolt Universal at 210 \u00B0 F must be between 29.5 and 290.";
            setError({ ...error, ...update });
        }

        if (field === "viscosity" && viscosityState["ViscosityType"] === 1 && viscosityState["viscosity"] >= 2 && viscosityState["viscosity"] <= 900 || viscosityState["viscosity"] === "") {
            let update = error;
            update["style"] = "info padb15 ";
            setError({ ...error, ...update });
        } else if (field === "viscosity" && viscosityState["ViscosityType"] === 2 && viscosityState["viscosity"] >= 1.141 && viscosityState["viscosity"] <= 119.9 || viscosityState["viscosity"] === "") {
            let update = error;
            update["style"] = "info padb15 ";
            setError({ ...error, ...update });
        } else if (field === "viscosity" && viscosityState["ViscosityType"] === 3 && viscosityState["viscosity"] >= 32.1 && viscosityState["viscosity"] <= 9600 || viscosityState["viscosity"] === "") {
            let update = error;
            update["style"] = "info padb15 ";
            setError({ ...error, ...update });
        } else if (field === "viscosity" && viscosityState["ViscosityType"] === 4 && viscosityState["viscosity"] >= 21 && viscosityState["viscosity"] <= 425 || viscosityState["viscosity"] === "") {
            let update = error;
            update["style"] = "info padb15 ";
            setError({ ...error, ...update });
        } else if (field === "viscosity" && viscosityState["ViscosityType"] === 5 && viscosityState["viscosity"] >= 32.6 && viscosityState["viscosity"] <= 4175 || viscosityState["viscosity"] === "") {
            let update = error;
            update["style"] = "info padb15 ";
            setError({ ...error, ...update });
        } else if (field === "viscosity" && viscosityState["ViscosityType"] === 6 && viscosityState["viscosity"] >= 29.5 && viscosityState["viscosity"] <= 290 || viscosityState["viscosity"] === "") {
            let update = error;
            update["style"] = "info padb15 ";
            setError({ ...error, ...update });
        }
        else {
            let update = error;
            update["style"] = "errortext";
            setError({ ...error, ...update });
        }
    }
    return (

        <div className={classes.root}>
            <div className="mar25">
                <div className="breadcurmbg mb25">
                    <span>Bunker Master </span>
                    <span className="bcarrow">  </span>
                    <span>Viscosity Calculation</span>
                </div>
                <AppBar position="static" className="custom-tabs">
                    <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                        <Tab label="Viscosity - Temperature Constants" {...a11yProps(0)} />
                        <Tab label="Viscosity - Temperature Calculation" {...a11yProps(1)} />
                        <Tab label="Viscosity Conversion" {...a11yProps(2)} />

                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0} className="custom-tab-section">

                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk">
                            <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">Viscosity-Temperature related Calculations</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p>This module performs the Viscosity related calculations:</p>
                                        <ul>
                                            <li>Determining Viscosity - Temperature constants (see example 1).  </li>
                                            <li>Calculating the Viscosity at a different temperature (see example 2).  </li>

                                        </ul>
                                        <p className="subtitle">Example 1 - Calculation of Viscosity / Temperature relationship constants</p>
                                        <img className="maxwidth100" src="/assets/images/Viscosity-Calculation-1.jpg"></img>


                                        <p><b>Note:</b> Fuel Constants A & B are calculated in accordance with method ASTM D 341.
                                            Viscosity Index (VI) is calculated in accordance with method ASTM D 2270.
                                            The Bunker Master 1 constant is shown for reference only.
                                        </p>

                                        <p className="subtitle">Example 2 - Calculation of a viscosity at a different temperature</p>
                                        <img className="maxwidth100" src="/assets/images/Viscosity-Calculation-2.jpg"></img>
                                        <p><b>Note:</b> Calculation of Viscosity at a different temperature is done in accordance with ASTM D 341.

                                        </p>


                                        <p><b>Note:</b> Calculation of the temperature needed to obtain a certain viscosity is done in accordance with ASTM D 341.</p>
                                        <p><b>Note:</b> For cases where only 1 viscosity measurement at 1 temperature is known, the application will use a set of default constants A & B, which have been calculated using 4 years of viscosity test data at 50 and 80 °C. At the time of writing, these default constants are:
                                        </p>
                                        <ul>
                                            <li>Fuel Constant A : 9.4477  </li>
                                            <li>Fuel Constant B : 3.6116 </li>
                                        </ul>

                                        <p>Certain default settings can be set in the properties module. When you open the quantity module, you can set base values and default settings like commodity, base temperature and volume unit for that particular calculation. However once a row has been added to the grid, these settings can no longer be changed, unless all data is cleared from the grid.

                                        </p>

                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Box>

                    <Grid container spacing={3}  >

                        <Grid item xs={12} md={4} className="pt0">


                            <Box component="span" className="bunkarinputw1 visco1">
                                <label for="Density"> 1st Viscosity at T1<sup>o</sup>C, mm2/s </label>

                                <BootstrapInput
                                    type="number"
                                    className={fieldClass.ViscosityNo1 ? "mt0" : "error"}
                                    onChange={(e) => onValuesChange(e.target.value, "ViscosityNo1")} value={calcFields.ViscosityNo1} />
                                <span className={fieldClass.ViscosityNo1 ? "userinfo" : "errortext"}>Viscosity No1 is required.</span>
                                <span className={info.ViscosityNo1 ? "info padb15 " : "errortext"}>Viscosity No1 must be Positive Numeric Value</span>
                            </Box>



                            <Box component="span" className="bunkarinputw1 visco1">
                                <label for="Density"> Temperature T1, <sup>o</sup>C  </label>
                                <BootstrapInput
                                    type="number"
                                    className={fieldClass.TemperatureNo1 ? "mt0" : "error"}
                                    onChange={(e) => onValuesChange(e.target.value, "TemperatureNo1")} value={calcFields.TemperatureNo1} />
                                <span className={fieldClass.TemperatureNo1 ? "userinfo" : "errortext"}>Temperature No1 is required.</span>
                                <span className={info.TemperatureNo1 ? "info padb15 " : "errortext"}>Temperature No1 must be Positive Numeric Value</span>
                            </Box>

                            <Box component="span" className="bunkarinputw1 visco1 ">
                                <label for="Density"> 2nd Viscosity at T2 <sup>o</sup>C, mm2/s</label>
                                <BootstrapInput
                                    type="number"
                                    className={fieldClass.ViscosityNo2 ? "mt0" : "error"}
                                    onChange={(e) => onValuesChange(e.target.value, "ViscosityNo2")} value={calcFields.ViscosityNo2} />
                                <span className={fieldClass.ViscosityNo2 ? "userinfo" : "errortext"}>Viscosity No2 is required.</span>
                                <span className={info.ViscosityNo2 ? "info padb15 " : "errortext"}>Viscosity No2 must be a numeric value between 0.5 and 1000 kg/m3</span>
                            </Box>

                            <Box component="span" className="bunkarinputw1 visco1" >
                                <label>Temperature T2 <sup>o</sup>C</label>
                                <BootstrapInput
                                    type="number"
                                    className={fieldClass.TemperatureNo2 ? "mt0" : "error"}
                                    onChange={(e) => onValuesChange(e.target.value, "TemperatureNo2")} variant="filled" value={calcFields.TemperatureNo2} />
                                <span className={fieldClass.TemperatureNo2 ? "userinfo" : "errortext"}>Temperature No2 is required.</span>
                                <span className={info.TemperatureNo2 ? "info padb15 " : "errortext"}>Temperature No2 must be Positive Numeric Value</span>
                            </Box>
                            <br></br><br></br>
                            <Grid item xs={12} md={12} className=" ">

                                <button type="button" className={classes.btn1} onClick={onResetconst} >Reset</button>{''}
                                <button type="reset" className={classes.btn2} onClick={Calculation}  >Calculate</button>
                            </Grid>
                        </Grid>



                        <Grid item xs={12} md={8} className="pt20">

                            <br /><br /><br />


                            <Box component="div" className="resultbox ">
                                <p>Results</p>
                                <Box component="div" className="bunkarinput resultinner">

                                    <form className={classes.root} noValidate autoComplete="off">
                                        <Grid container spacing={3} className="pt20"  >

                                            <Grid item xs={12} md={6} className="pt0">
                                                <Box component="div" className="padbtm25">
                                                    <label className="resultLabel"> Calculated Fuel Constant A  </label>
                                                    <TextField id="standard-basic" value={ViscocityResult.FuelConstantA} />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={6} className="pt0">


                                                <Box component="div" className=" padbtm25">
                                                    <label className="resultLabel">  Calculated Fuel Constant B </label>
                                                    <TextField id="standard-basic" value={ViscocityResult.FuelConstantB} />


                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={6} className="pt0">

                                                <Box component="div" className="padbtm25 ">
                                                    <label className="resultLabel"> Calculated Viscosity Index (VI) </label>
                                                    <TextField id="standard-basic" value={ViscocityResult.ViscosityIndex} />


                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} md={6} className="pt0">

                                                <Box component="div" className=" ">
                                                    <label className="resultLabel"> Bunker Master 1 Constant (K) </label>
                                                    <TextField id="standard-basic" value={ViscocityResult.ShellViscosityConstant} />

                                                </Box>
                                            </Grid> </Grid>

                                    </form>
                                </Box>



                            </Box>
                            <span className={errVal}>{errmsg}</span>

                        </Grid>
                    </Grid>

                </TabPanel>
                <TabPanel value={value} index={1} className="custom-tab-section">

                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk">
                            <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">Viscosity-Temperature related Calculations</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p>This module performs the Viscosity related calculations:</p>
                                        <ul>

                                            <li>Calculating Temperature to obtain a certain viscosity (see example ).  </li>
                                        </ul>


                                        <p className="subtitle">Example  - Calculation of the temperature required to obtain a certain viscosity</p>
                                        <img className="maxwidth100" src="/assets/images/Viscosity-Calculation-3.jpg"></img>
                                        <p><b>Note:</b> Calculation of the temperature needed to obtain a certain viscosity is done in accordance with ASTM D 341.</p>
                                        <p><b>Note:</b> For cases where only 1 viscosity measurement at 1 temperature is known, the application will use a set of default constants A & B, which have been calculated using 4 years of viscosity test data at 50 and 80 °C. At the time of writing, these default constants are:
                                        </p>
                                        <ul>
                                            <li>Fuel Constant A : 9.4477  </li>
                                            <li>Fuel Constant B : 3.6116 </li>
                                        </ul>

                                        <p>Certain default settings can be set in the properties module. When you open the quantity module, you can set base values and default settings like commodity, base temperature and volume unit for that particular calculation. However once a row has been added to the grid, these settings can no longer be changed, unless all data is cleared from the grid.

                                        </p>

                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Box>

                    <Grid container spacing={3}  >

                        <Grid item xs={12} md={5} className="pt0">
                            <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl}>

                                <Box component="span" className="bunkarinputw1 visco1">
                                    <label for="Density">Calculation Type </label>

                                    <Select labelId="outlined-label" className="mr20 bunkerselect" onChange={(e) => onChangestatus(e.target.value, "calcType")} value={Temp.calcType}>
                                        <MenuItem value={10} >Viscosity at different temperatures</MenuItem>
                                        <MenuItem value={20}>Temperature required to obtain a viscosity</MenuItem>

                                    </Select>

                                </Box>
                            </FormControl>
                            <Box component="span" className="bunkarinputw1 visco1">
                                <label for="Density">1st Viscosity at T1<sup>o</sup>C, mm2/s </label>


                                <BootstrapInput
                                    type="number"
                                    className={fieldClass2.ViscosityNo1 ? "mt0" : "error"}
                                    onChange={(e) => onChangestatus(e.target.value, "ViscosityNo1")} value={Temp.ViscosityNo1} />

                                <span className={fieldClass2.ViscosityNo1 ? "userinfo" : "errortext"}>ViscosityNo1 is required.</span>
                                <span className={info2.ViscosityNo1 ? "info padb15 " : "errortext"}>ViscosityNo1 must be Positive Numeric Value</span>
                            </Box>

                            <Box component="span" className="bunkarinputw1 visco1">
                                <label for="Density"> Temperature T1,<sup>o</sup>C </label>
                                <BootstrapInput
                                    type="number"
                                    className={fieldClass2.TemperatureNo1 ? "mt0" : "error"}
                                    onChange={(e) => onChangestatus(e.target.value, "TemperatureNo1")} value={Temp.TemperatureNo1} />
                                <span className={fieldClass2.TemperatureNo1 ? "userinfo" : "errortext"}>TemperatureNo1 is required.</span>
                                <span className={info2.TemperatureNo1 ? "info padb15 " : "errortext"}>TemperatureNo1 must be Positive Numeric Value</span>
                            </Box>
                            {Temp.calcType === 10 ?
                                <Box component="span" className="bunkarinputw1 visco1">
                                    <label for="Density"> Temperature T2,<sup>o</sup>C </label>
                                    <BootstrapInput
                                        type="number"
                                        className={fieldClass2.TemperatureNo2 ? "mt0" : "error"}
                                        onChange={(e) => onChangestatus(e.target.value, "TemperatureNo2")} value={Temp.TemperatureNo2} />

                                    <span className={fieldClass2.TemperatureNo2 ? "userinfo" : "errortext"}>TemperatureNo2 is required.</span>
                                    <span className={info2.TemperatureNo2 ? "info padb15 " : "errortext"}>TemperatureNo2 must be Positive Numeric Value</span>
                                </Box> :
                                <Box component="span" className="bunkarinputw1 visco1">
                                    <label for="Density"> 2nd Viscosity at T2<sup>o</sup>C, mm2/s </label>
                                    <BootstrapInput type="number" onChange={(e) => onChangestatus(e.target.value, "ViscosityNo2")} className={fieldClass2.ViscosityNo2 ? "mt0" : "error"} value={Temp.ViscosityNo2} />
                                    {/* <BootstrapInput /> */}
                                    <span className={fieldClass2.ViscosityNo2 ? "userinfo" : "errortext"}>ViscosityNo2 is required.</span>
                                    <span className={info2.ViscosityNo2 ? "info padb15 " : "errortext"}>ViscosityNo2 must be Positive Numeric Value</span>
                                </Box>}


                            <Box component="span" className="bunkarinputw">

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="checkedA"
                                            disabled={checkBox.disabled}
                                            checked={checkBox.checked}
                                            onChange={(e) => onChecked(e.target.checked)}
                                        />
                                    }
                                    label="Use Calculated Fuel constants"
                                    color="primary"
                                    labelPlacement=" insidelabel"
                                />

                            </Box>
                            {/* <Box component="span" className="bunkarinputw2">
                                <label for="Density">Calculated Temperature T2, <sup>o</sup>C </label>
                                <BootstrapInput />
                            </Box> */}
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <br /> <br /> <br />
                            <Box component="div" className="resultbox">
                                <p>Results</p>
                                <Box component="div" className="bunkarinput resultinner">

                                    <form className={classes.root} noValidate autoComplete="off">



                                        <Box component="div" className="padbtm25">
                                            {Temp.calcType === 10 ? <label className="resultLabel"> Calculated Viscosity at T2,<sup>o</sup>C </label> :
                                                <label className="resultLabel"> Calculated Temperature at T2,<sup>o</sup>C </label>}
                                            <TextField id="standard-basic" value={Number(conv).toFixed(1)} />
                                            <span className="resultmv"> <sup>o</sup>C</span>
                                        </Box>



                                    </form>
                                </Box>



                            </Box>
                        </Grid>

                        <Grid item xs={12} md={12}>

                            <button type="button" className={classes.btn1} onClick={onResettemp} >Reset</button>{''}
                            <button type="reset" className={classes.btn2} onClick={Derivative}  >Calculate</button>
                        </Grid>
                    </Grid>




                </TabPanel>
                <TabPanel value={value} index={2} className="custom-tab-section">

                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk">
                            <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">Viscosity Conversion</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p>TThis module performs Viscosity conversions. Viscosity values can be converted between Viscosity in :
                                        </p>
                                        <ul>
                                            <li>Kinematic Viscosity at 50°C in mm2/s
                                            </li>
                                            <li>°Engler at 50°C in °E
                                            </li>
                                            <li>Redwood No.1 at 100°F in RW1
                                            </li>
                                            <li>Saybolt Furol at 100°F in SSF
                                            </li>
                                            <li>Saybolt Universal at 122°F in SSU
                                            </li>
                                            <li>Saybolt Universal at 210°F in SSU
                                            </li>

                                        </ul>
                                        <p className="subtitle">Example</p>
                                        <img className="maxwidth100" src="/assets/images/Viscosity-Calculation-4.jpg"></img>

                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Box>

                    <Grid container spacing={3}  >

                        <Grid item xs={12} md={7} className="pt0">
                            <br></br>

                            <FormControl MuiFormGroup-row variant="outlined" className={classes.formControl}>
                                <Box component="span" className="bunkarinputw2">
                                    <label for="Density">Calculation Type </label>

                                    <Select labelId="outlined-label" className="mr20 bunkerselect"
                                        onChange={(e) => onViscosityValuesChange(e.target.value, "ViscosityType")}
                                        value={viscosityState.ViscosityType}
                                    >
                                        <MenuItem value={1}>Kinematic viscosity at 50<sup>o</sup>C, mm2/s</MenuItem>
                                        <MenuItem value={2}> Degrees Engler at 50<sup>o</sup>C, 0E</MenuItem>
                                        <MenuItem value={3}> Redwood No. 1 at 100<sup>o</sup>F, RW1</MenuItem>
                                        <MenuItem value={4}> Saybolt Furol at 100<sup>o</sup>F, SSF</MenuItem>
                                        <MenuItem value={5}>Saybolt Universal at 122<sup>o</sup>F, SSU</MenuItem>
                                        <MenuItem value={6}>Saybolt Universal at 210<sup>o</sup>F, SSU</MenuItem>
                                    </Select>
                                    <br></br> <br></br>
                                    <BootstrapInput
                                        type="number"
                                        value={viscosityState.viscosity}
                                        onChange={(e) => onViscosityValuesChange(e.target.value, "viscosity")}
                                        className={validate.style}
                                    />
                                    <span className={validate.textstyle}>{validate.msg}</span>
                                    <span className={error.style}>{error.msg}</span>
                                </Box>
                            </FormControl>


                        </Grid>
                        <Grid item xs={12} md={12}>

                            <button type="button" className={classes.btn1} onClick={onReset}>Reset</button>{''}
                            <button type="reset" className={classes.btn2} onClick={CalculationViscosityConversion}>Calculate</button>
                        </Grid>
                        <Grid item xs={12} md={7} className="pt0">
                            <br></br>
                            <Box component="div" className="filtercontainer">
                                <TableContainer component={Paper}  >
                                    <Table className={classes.table} aria-label="customized table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Viscosity Unit</StyledTableCell>
                                                <StyledTableCell >Value</StyledTableCell>


                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {/* {rows.map((row) => (
                                                <StyledTableRow key={row.name}>
                                                    <StyledTableCell component="th" scope="row">
                                                        {row.Parameter}
                                                    </StyledTableCell>
                                                    <StyledTableCell  >{row.Unit}</StyledTableCell>


                                                </StyledTableRow>
                                            ))} */}

                                            {Object.keys(visresult).length > 0 && Object.entries(visresult).map((row) => (

                                                <StyledTableRow key={row[0]}>
                                                    <StyledTableCell component="th" scope="row">
                                                        {ViscosityTypes[row[0]]}
                                                    </StyledTableCell>
                                                    <StyledTableCell  >{row[1]}</StyledTableCell>

                                                </StyledTableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <br></br>


                            </Box>

                        </Grid>


                    </Grid>

                </TabPanel>






            </div>
        </div>
    );
}
export default ViscocityCal;
